// extracted by mini-css-extract-plugin
export default {"modal":"historyTransactionModal_modal__bWlsl","closeBtn":"historyTransactionModal_closeBtn__L+K7R","popup":"historyTransactionModal_popup__go9bI"};